import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Upload, Download, Images } from "lucide-react";
import { PhotoLibrary } from "../../components/LessonEditorParts";
import { FeedbackInbox } from "../../components/LessonFeedback";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useApi, Loading, inputCls, btn, StatusChip, SampleBadge } from "../../components/kit";

export default function Courses() {
  const { data, loading, reload } = useApi("/courses");
  const [title, setTitle] = useState("");
  const [lib, setLib] = useState(false);
  const nav = useNavigate();
  if (loading) return <Loading />;
  const create = async (e) => {
    e.preventDefault();
    try { const r = await api.post("/courses", { title }); nav(`/admin/courses/${r.data.id}`); } catch (err) { toast.error(errMsg(err)); }
  };
  const tpl = async () => {
    const r = await api.get("/courses/template");
    const url = URL.createObjectURL(new Blob([JSON.stringify(r.data, null, 2)], { type: "application/json" }));
    const a = document.createElement("a"); a.href = url; a.download = "dcbc_course_template.json"; a.click();
  };
  const imp = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    try { const r = await api.post("/courses/import", fd); toast.success("Imported as a DRAFT course."); reload(); nav(`/admin/courses/${r.data.id}`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4">
      <FeedbackInbox />
      <form onSubmit={create} className="flex flex-wrap gap-2">
        <input className={`${inputCls} max-w-md`} required placeholder="New course title" aria-label="New course title" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="course-new-title" />
        <button className={btn.primary} data-testid="course-create-button"><Plus className="h-4 w-4" /> Create draft course</button>
        <button type="button" className={btn.ghost} onClick={tpl} data-testid="course-template-button"><Download className="h-4 w-4" /> Template</button>
        <label className={`${btn.ghost} cursor-pointer`}><Upload className="h-4 w-4" /> Import course file<input type="file" accept=".json,application/json" className="sr-only" onChange={(e) => e.target.files[0] && imp(e.target.files[0])} data-testid="course-import-input" /></label>
        <button type="button" className={btn.ghost} onClick={() => setLib(true)} data-testid="courses-photo-library-button"><Images className="h-4 w-4" /> Photo library</button>
      </form>
      {lib && <PhotoLibrary onClose={() => setLib(false)} />}
      <div className="grid gap-3">{data.filter((c) => c.kind !== "external").map((c) => (
        <Link key={c.id} to={`/admin/courses/${c.id}`} data-testid={`course-row-${c.id}`} className="flex flex-col gap-2 rounded-xl border bg-white p-4 hover:border-[color:var(--ink)] sm:flex-row sm:items-center">
          <div className="flex-1"><p className="font-semibold flex items-center gap-2">{c.title} <SampleBadge show={c.is_demo} /></p><p className="text-sm text-muted-foreground line-clamp-1">{c.description}</p></div>
          <div className="flex flex-wrap items-center gap-2"><span role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), nav(`/admin/courses/${c.id}/preview`))} onClick={(e) => { e.preventDefault(); e.stopPropagation(); nav(`/admin/courses/${c.id}/preview`); }} className="rounded-md border px-2 py-1 text-xs font-semibold hover:bg-muted" data-testid={`course-preview-${c.id}`}>Preview</span>{c.published_version ? <StatusChip status="published" label={`Published v${c.published_version}`} /> : null}{c.has_draft && <StatusChip status="draft" label="Draft in progress" />}</div>
        </Link>))}</div>
    </div>
  );
}
